var _templateObject;

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

import React from 'react';
import i18n from '@pureartisan/simple-i18n';
import { hasValue } from './../utils';
import styled from 'styled-components';
import { ChoroplethLegend } from '../Legend/ChoroplethLegend';
/**
 * Get robotext for the sd bucket
 * @param Number sd Number 0 - 4
 */

export var getSDRobo = function getSDRobo(_ref) {
  var sd = _ref.sd,
      region = _ref.region;
  var sdValue = i18n.translate("SD_" + sd);
  return i18n.translate("SD_ROBO", {
    sdValue: sdValue,
    region: region
  });
};
var SdWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  .choropleth-legend {\n    width: 80%;\n  }\n"])));

var IndicatorSdScale = function IndicatorSdScale(_ref2) {
  var indicator = _ref2.indicator,
      value = _ref2.value,
      region = _ref2.region,
      props = _objectWithoutPropertiesLoose(_ref2, ["indicator", "value", "region"]);

  if (!hasValue(value)) return null;
  return /*#__PURE__*/React.createElement(SdWrapper, props, /*#__PURE__*/React.createElement("p", {
    className: "gotham12 mb-3",
    dangerouslySetInnerHTML: {
      __html: getSDRobo({
        sd: value,
        region: region
      })
    }
  }), /*#__PURE__*/React.createElement(ChoroplethLegend, {
    activeIndexes: [value],
    noLabels: true,
    condensed: true
  }));
};

export default IndicatorSdScale;